import { AsyncStateNotification } from '@ui/notifications';
import { createAsyncSelectors } from '@lib/selectors';
import { Divider } from 'antd';
import { importsActions } from '@sonar-software/sonar-imports';
import { ImportStatistics } from './ImportStatistics';
import { LastSyncStatus } from './LastSyncStatus';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { useAsyncStateWithPreload } from '@hooks';
import { Else, If, Then } from 'react-if';
const selectors = createAsyncSelectors((state) => state.imports.salesforce.summary.get);
export const LastSyncSummary = () => {
    const { data, isRequested } = useAsyncStateWithPreload(selectors, importsActions.requestGetImportsSalesforceSummary, true);
    return (React.createElement(React.Fragment, null,
        React.createElement(If, { condition: isRequested },
            React.createElement(Then, null,
                React.createElement(LoadingSpinner, null)),
            React.createElement(Else, null,
                React.createElement("div", { id: 'last-sync-summary' },
                    React.createElement(ImportStatistics, { summary: data }),
                    React.createElement(Divider, null),
                    React.createElement(LastSyncStatus, null)))),
        React.createElement(AsyncStateNotification, { errored: NOTIFICATIONS_COPY.ERROR_IMPORT_SUMMARY, failed: NOTIFICATIONS_COPY.FAILED_IMPORT_SUMMARY, stateSelector: selectors.state })));
};
